const teamPhoto = "/media/telefonka-team.jpg";

const SectionHeading = ({ kicker, title, sub }) => (
  <div className="text-center mb-12 md:mb-14 max-w-3xl mx-auto">
    <span className="tk-eyebrow">
      <span className="tk-divider" />
      {kicker}
      <span className="tk-divider" />
    </span>
    <h2 className="font-serif text-4xl sm:text-5xl mt-5 text-[var(--ink)] leading-tight">
      {title}
    </h2>
    {sub && <p className="mt-4 text-[var(--ink-soft)] leading-relaxed">{sub}</p>}
  </div>
);

export default function AboutTeam({ t }) {
  const isHungarian = t.team.kicker === "Rólunk";
  const teamCopy = isHungarian
    ? {
        sub:
          "A Telefonka egy közös ötletből és abból a vágyból született, hogy az esküvők legszemélyesebb pillanatai ne csak képeken, hanem hangokban és történetekben is megmaradjanak. Hárman dolgozunk azon, hogy a Telefonka az első ötlettől egészen az elkészült hang- és videóemlékekig különleges és szerethető élmény legyen.",
        members: [
          {
            name: "Gellért",
            role: "Hang- és videóprodukció • Utómunka",
            description:
              "Gellért gondoskodik arról, hogy a vendégek által hátrahagyott pillanatok a lehető legszebb formában maradjanak meg. A hang- és videóanyagok feldolgozásával, rendezésével és utómunkájával válik a nyers felvételekből valódi emlék.",
          },
          {
            name: "Anna",
            role: "Grafikus • A Telefonka megálmodója",
            description:
              "Anna álmodta meg a Telefonka világát és vizuális megjelenését. Ő felel azért, hogy minden részlet – a készülékektől a kártyákon át a teljes arculatig – egységes és szerethető legyen.",
          },
          {
            name: "Csabi",
            role: "Üzletfejlesztés • Háttérfolyamatok",
            description:
              "Csabi a Telefonka működésének és fejlődésének hátterén dolgozik. Az üzletfejlesztés, a digitális megoldások és a háttérfolyamatok összehangolásával gondoskodik arról, hogy az ötletekből működő szolgáltatás legyen.",
          },
        ],
      }
    : {
        sub:
          "Telefonka grew from a shared idea and a desire to preserve the most personal moments of weddings not only in photographs, but in voices and stories too. The three of us work together to make every step, from the first idea to the finished audio and video memories, feel thoughtful, personal and memorable.",
        members: [
          {
            name: "Gellért",
            role: "Audio & video production • Post-production",
            description:
              "Gellért makes sure the moments left by guests are preserved in their best form. Through editing, organising and post-producing the recordings, he turns raw audio and video into lasting memories.",
          },
          {
            name: "Anna",
            role: "Graphic designer • Creator of Telefonka",
            description:
              "Anna created Telefonka’s visual world. She shapes every detail – from the phones and cards to the complete brand identity – so the experience feels consistent, distinctive and warm.",
          },
          {
            name: "Csabi",
            role: "Business development • Operations",
            description:
              "Csabi works behind the scenes on Telefonka’s growth and day-to-day operation. He brings business development, digital solutions and internal processes together to turn ideas into a smoothly working service.",
          },
        ],
      };

  return (
    <section id="team" className="py-20 md:py-28 tk-section-anchor">
      <div className="max-w-6xl mx-auto px-5 md:px-10">
        <SectionHeading kicker={t.team.kicker} title={t.team.title} sub={teamCopy.sub} />

        <div className="mx-auto mb-10 md:mb-14 max-w-4xl overflow-hidden rounded-[1.75rem] bg-[var(--beige-100)] shadow-sm">
          <img
            src={teamPhoto}
            alt={isHungarian ? "A Telefonka csapata" : "The Telefonka team"}
            width="600"
            height="400"
            loading="lazy"
            decoding="async"
            className="block h-auto w-full"
          />
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7 lg:gap-8 items-stretch">
          {teamCopy.members.map((member) => (
            <article
              key={member.name}
              className="tk-card flex h-full flex-col bg-white p-7 md:p-8 lg:p-9 text-center"
            >
              <h3 className="font-serif text-4xl text-[var(--ink)]">{member.name}</h3>
              <div className="mt-2 min-h-[2.75rem] flex items-center justify-center">
                <p className="text-xs sm:text-sm uppercase tracking-[0.12em] text-[var(--burgundy)] leading-relaxed">
                  {member.role}
                </p>
              </div>
              <div className="w-10 h-px bg-[var(--burgundy)]/30 mx-auto my-5" aria-hidden="true" />
              <p className="text-sm text-[var(--ink-soft)] leading-relaxed flex-1 max-w-sm mx-auto">
                {member.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
